enum MonitorTriggerType {
  Later = 'Later',
  Immediate = 'Immediate',
}

const TriggerTypePropLabel = {
  [MonitorTriggerType.Immediate]: 'Now (Run verification now)',
  [MonitorTriggerType.Later]: 'On',
};

export const getMonitorTriggerOptionAsList = (): CommonList[] => {
  return Object.keys(MonitorTriggerType).map(
    (key: string): CommonList => {
      return {
        id: key,
        label: TriggerTypePropLabel[key],
      };
    },
  );
};

export default MonitorTriggerType;
